<!-- Barre de navigation -->
<nav
  class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme shadow-sm rounded-bottom"
  id="layout-navbar">
  <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
    <a class="nav-item nav-link px-0 me-xl-4 text-center" href="javascript:void(0)">
      <i class="bx bx-menu bx-sm text-muted"></i>
    </a>
  </div>

  <div class="navbar-nav-right d-flex align-items-center justify-content-between w-100" id="navbar-collapse">
    <!-- Sélection entreprise à gauche -->
    <ul class="navbar-nav flex-row align-items-center">
      <li class="nav-item navbar-dropdown dropdown-user dropdown">
        <ng-select class="" [(ngModel)]="id_entreprise" (change)="entreprise_change()">
          <ng-option value="" disabled>Toutes les entreprises</ng-option>
          @for (one_entreprise of api.infos.les_entreprises; track $index) {
          <ng-option [value]="one_entreprise.id_entreprise">
            <img
              [src]="one_entreprise.logo_entreprise?api.files_base_url + one_entreprise.logo_entreprise : '../assets/img/logo_placeholder.png'"
              alt="•••" class="img-fluid" style="max-height: 15px;width: 15px;">
            {{ one_entreprise.nom }}</ng-option>
          }
        </ng-select>
      </li>
    </ul>

    <!-- Éléments à droite -->
    <ul class="navbar-nav flex-row align-items-center gap-3">
      <li class="nav-item navbar-dropdown dropdown-user dropdown">
        <a (click)="show_notification()"
          class="nav-link dropdown-toggle hide-arrow d-flex align-items-center position-relative  py-0 px-1"
          href="javascript:void(0);" data-bs-toggle="dropdown">
          <i class="bi"
            [ngClass]="{'bi-bell':les_notification_non_lues.length==0,'bi-bell-fill':les_notification_non_lues.length>0}"></i>
          @if (les_notification_non_lues.length>0) {
          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {{les_notification_non_lues.length}}
            <span class="visually-hidden">unread messages</span>
          </span>
          }
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow-lg rounded-3">
          <li *ngIf="!granted">
            <a class="dropdown-item d-flex align-items-center" (click)="not.requestPermission()">
              <i class="bx bx-bell me-2 text-primary"></i>
              <span class="align-middle">Activer la notification</span>
            </a>
          </li>
          @for (one_date of list_notifications; track $index) {
          <li>
            <div class="d-flex align-items-center justify-content-center text-muted text-xs">
              {{one_date.created_at|date:'dd MMMM'}}
            </div>
          </li>
          @for (one_notification of one_date.les_details; track $index) {
          <li>
            <a class="dropdown-item d-flex align-items-center">
              <i class="bi me-2"
                [ngClass]="{'bi-bell':one_notification.read_at!=null,'bi-bell-fill':one_notification.read_at==null}"></i>
              <span class="align-middle">{{one_notification.titre}}</span>
            </a>
          </li>
          }
          }
          <li>
            <div class="dropdown-divider"></div>
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" [routerLink]="['/home/rappel']">
              <i class="bi bi-power me-2 text-danger"></i>
              <span class="align-middle">Voir plus de notifications</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Bouton IA -->
      <!-- <li class="nav-item clique">
        <button (click)="wrapper=true" class="btn btn-link text-primary fw-semibold d-flex align-items-center" 
                type="button" data-bs-toggle="offcanvas" 
                data-bs-target="#offcanvasWithBothOptions" 
                aria-controls="offcanvasWithBothOptions">
          <i class="bi bi-robot me-1"></i> IA
        </button>
      </li> -->

      <!-- Mise à jour -->
      <li class="nav-item">
        <select class="border-0" [(ngModel)]="api.version.id" (change)="changerVersion(api.version.id)">
          @for (une_version of api.infos.les_versions; track $index) {
          <option [value]="une_version">
            {{ une_version }}
          </option>
          }
        </select>
      </li>

      <!-- <li class="nav-item clique">
        <a class="dropdown-item clique d-flex align-items-center text-dark" (click)="checkForUpdates()">
          <i class="bx bx-download me-2 text-primary"></i>
          <span class="align-middle">{{ loading_update ? "En cours ..." : api.version.id }}</span>
        </a>
      </li> -->

      <!-- Profil utilisateur -->
      <li class="nav-item navbar-dropdown dropdown-user dropdown">
        <a class="nav-link dropdown-toggle hide-arrow d-flex align-items-center" href="javascript:void(0);"
          data-bs-toggle="dropdown">
          <div class="avatar avatar-online">
            <img src="../assets/img/logo_jb.png" alt class="w-px-40 h-auto rounded-circle" />
          </div>
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow-lg rounded-3">
          <li>
            <a class="dropdown-item" [routerLink]="['/home/utilisateur/profil']">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar avatar-online">
                    <img src="../assets/img/logo_jb.png" alt class="w-px-40 h-auto rounded-circle" />
                  </div>
                </div>
                <div class="flex-grow-1">
                  <span class="fw-semibold d-block text-dark">
                    {{ api.infos.utilisateur.prenom + " " + api.infos.utilisateur.nom }}
                  </span>
                  <small class="text-muted">{{ api.infos.current_entreprise.libelle_pointage }}</small>
                </div>
              </div>
            </a>
          </li>
          <li>
            <div class="dropdown-divider"></div>
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" [routerLink]="['/home/profil']">
              <i class="bi bi-person me-2 text-primary"></i>
              <span class="align-middle">Mon profil</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center clique" [routerLink]="['/home/caisse/pv/sign']">
              <i class="bi bi-pen me-2 text-primary"></i>
              <span class="align-middle">Ajouter une signature</span>
            </a>
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center clique" (click)="checkForUpdates()">
              <i class="bi bi-download me-2 text-primary"></i>
              <span class="align-middle">Mettre à jour</span>
            </a>
          </li>
          <li>
            <div class="dropdown-divider"></div>
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" [routerLink]="['/public/deconnexion']">
              <i class="bi bi-power me-2 text-danger"></i>
              <span class="align-middle">Déconnexion</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- Offcanvas IA -->
<div class="offcanvas offcanvas-start shadow-lg" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions"
  aria-labelledby="offcanvasWithBothOptionsLabel">
  <div class="offcanvas-header bg-light p-4">
    <h5 class="offcanvas-title fw-bold text-dark" id="offcanvasWithBothOptionsLabel">JantBi IA</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body p-4">
    <!-- <app-list-message [wrapper]="wrapper" *ngIf="wrapper"></app-list-message> -->
  </div>
</div>